jQuery(function ($) {

    $('#banner-slider').owlCarousel({
        loop:true,
        margin:0,
        nav: false,
        dots: true,
        autoplay:true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplayTimeout:6000,
        smartSpeed: 1000,
        paginationSpeed: 1000,
        dragEndSpeed: 1000,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })

    $('#client-slider').owlCarousel({
        loop:true,
        margin: 20,
        nav:false,
        dots: true,
        autoplay:true,
        animateOut: 'fadeOut',
        autoplayTimeout:4000,
        smartSpeed:1000,
        dragEndSpeed: 1000,
        autoplayHoverPause: false,
        autoHeight: true,
        responsive:{
            0:{
                items:2
            },
            768:{
                items:4
            },
            1200:{
                margin: 40,
                items:5
            },
        }
    })

    $('#testimony-slider').owlCarousel({
        loop:true,
        margin: 20,
        nav:false,
        dots: true,
        autoplay:true,
        animateOut: 'fadeOut',
        autoplayTimeout:4000,
        smartSpeed:1000,
        dragEndSpeed: 1000,
        autoplayHoverPause: false,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
            768:{
                items:3
            },
            1024:{
                items:3,
            },

            1532:{
                margin: 40,
                items:3
            },
        }
    })

    $('#promo-slider').owlCarousel({
        loop:true,
        margin: 20,
        nav: true,
        dots: false,
        autoplay:true,
        animateOut: 'fadeOut',
        autoplayTimeout:4000,
        smartSpeed:1000,
        dragEndSpeed: 1000,
        autoplayHoverPause: false,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
            768:{
                margin: 30,
                items:2
            },
            1532:{
                margin: 52,
                items:2
            },
        }
    })



});